
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import InputText from '@/components/molecules/InputText.vue'
import InputPassword from '@/components/molecules/InputPassword.vue'
import SquareSelect from '@/components/molecules/SquareSelect.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'
import { SelectItem } from '@/models/SelectItem'

/**
 * ユーザ情報モーダルのフォーマット
 */
@Component({
  components: {
    ModalWindow,
    LabelBase,
    InputText,
    InputPassword,
    SquareSelect,
    ButtonSubmit,
  },
})
export default class ModalUserData extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** セレクト部品 */
  @Ref()
  squareSelect!: SquareSelect

  /** 登録/編集の切り替え(登録ならtrue) */
  @Prop({ default: true })
  private isRegistMode!: boolean

  /** 選択項目一覧 */
  @Prop()
  private selectOptions!: SelectItem[]

  /** 選択項目の初期選択値 */
  @Prop()
  private optionDefaultCode!: string

  /** 送信ボタンのDisabled制御 */
  @Prop()
  private submitDisabled!: (nickname: string, password: string, confirm: string) => boolean

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: () => void

  /** ニックネーム */
  public nickname: string = ''

  /** パスワード */
  public password: string = ''

  /** パスワード確認 */
  public confirm: string = ''

  /**
   * 送信ボタンのDisabled制御
   *   入力値の変更を検知するため、getterでラップする
   *
   * @returns ニックネーム、パスワード、確認用パスワードが未入力ならtrue
   */
  private get disabled(): boolean {
    return this.submitDisabled(this.nickname, this.password, this.confirm)
  }

  /**
   * 選択中の項目
   *
   * @returns コード
   */
  public selectedValue(): string {
    return this.squareSelect.selectedValue()
  }

  /**
   * モーダルを開く
   *
   * @param nickname ニックネーム
   */
  public show(nickname?: string): void {
    // モーダルを開く際に各項目を初期化(引数がある場合は代入)
    this.nickname = nickname || ''
    this.password = ''
    this.confirm = ''
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
